<template>
  <v-dialog v-model="showDialog" persistent max-width="1000px">
    <v-card>
      <!-- <v-card-title  color="primary darken-4">
                                <span class="headline">AGREGAR SUCURSAL</span>
      </v-card-title>-->
      <v-toolbar color="primary darken-4" dark>
        <img
          :src="$store.state.iconoForm"
          height="42"
          alt="Acciones tipo producto"
        />
        <v-toolbar-title class="ml-0 pl-3">
          <span class="hidden-sm-and-down">{{ $store.state.tituloForm }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="showDialog = false">
          <v-icon danger>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="formLineaProducto" :v-model="true" lazy-validation>
            <v-flex xs12>
              <v-select
                v-model="lineaProducto.tipoProductoId"
                :items="tiposProducto"
                item-text="descripcion"
                item-value="tipoProductoId"
                label="Tipo de producto *"
                placeholder="Tipo de producto"
                single-line
                :rules="[
                  () =>
                    !!lineaProducto.tipoProductoId || 'El campo es requerido',
                ]"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                label="Descripción línea de producto *"
                v-model="lineaProducto.descripcion"
                placeholder="Descripción línea producto como SLIMFIT, REGULAR FIT, CHAROL, FORMAL"
                hint="Descripción linea (SLIMFIT, REGULAR FIT, CHAROL, FORMAL, DEPORTIVO)"
                :rules="[
                  () => !!lineaProducto.descripcion || 'El campo es requerido',
                ]"
                :counter="60"
                required
              ></v-text-field>
            </v-flex>
          </v-form>
        </v-container>
        <br />
        <small>* Indica que el campo es requerido</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="showDialog = false">Cerrar</v-btn>
        <v-btn
          color="primary darken-4"
          :loading="$store.state.operationInProgress"
          @click="saveLineaProducto"
          >Guardar</v-btn
        >
      </v-card-actions>
      <v-alert
        :value="$store.state.operationSuccess"
        color="success"
        icon="check_circle"
        transition="scale-transition"
        >Línea de producto guardado con éxito</v-alert
      >
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-card>
  </v-dialog>
</template>

<script>
import lineaProductoService from "@/services/lineaProductoService";
import tipoProductoService from "@/services/tipoProductoService";

export default {
  props: {
    lineaProducto: {
      type: Object,
    },
  },
  data() {
    return {
      showDialog: false,
      tiposProducto: [],
    };
  },
  mounted() {
    this.getTiposProducto();
  },
  methods: {
    openDialog() {
      this.showDialog = true;
    },
    getTiposProducto() {
      let self = this;

      tipoProductoService
        .getAll()
        .then((result) => {
          self.tiposProducto = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    saveLineaProducto() {
      let self = this;

      if (self.$refs.formLineaProducto.validate()) {
        self.operationStart();

        if (self.lineaProducto.lineaProductoId === 0) {
          self.addTipoProducto();
        } else {
          self.updateTipoProducto();
        }
      }
    },
    addTipoProducto() {
      let self = this;

      lineaProductoService
        .add(self.lineaProducto)
        .then((result) => {
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onLineaProductoAdded", result);

          setTimeout(() => {
            self.showDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    updateTipoProducto() {
      let self = this;

      lineaProductoService
        .update(self.lineaProducto)
        .then((result) => {
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onLineaProductoUpdated", result);

          setTimeout(() => {
            self.showDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    resetForm() {
      let self = this;
      self.operationReset();
      self.lineaProducto.lineaProductoId = 0;
      self.lineaProducto.tipoProductoId = 0;
      self.lineaProducto.descripcion = "";
      self.$refs.formLineaProducto.resetValidation();
    },
  },
};
</script>
